module.exports = __webpack_public_path__ + "static/media/ni-2.4febda9e.jpg";